/**
 * Versão do sistema de cobranças
 * Esta versão é exibida na barra lateral para informar aos usuários sobre atualizações
 */
export const SYSTEM_VERSION = '2.0.218';
export const LAST_UPDATE_DATE = '24/08/2026';
